import type { GetB2bOrderDetailsResponse } from '@Common/types/b2b/orders';

export const b2bOrdersTranslations = {
  sides: {
    buy: 'Buy',
    sell: 'Sell',
  } satisfies Record<GetB2bOrderDetailsResponse['side'], string>,
  status: {
    pending: 'Pending',
    filled: 'Filled',
    shares_canceled: 'Shares Canceled',
    rejected: 'Rejected',
    shares_new: 'Shares New',
    pending_funds: 'Pending Funds',
    shares_pending_arbitrage: 'Shares Pending Arbitrage',
    shares_pending_company: 'Shares Pending Company',
    shares_pending_campaign: 'Shares Pending Operation',
    shares_pending_reallocation: 'Shares Pending Reallocation',
    shares_pending_approval: 'Shares Pending Approval',
    shares_pending_cutoff_period: 'Shares Pending Cutoff Period',
    shares_pending_blocked_instrument: 'Shares Pending Blocked Instrument',
    shares_pending_triggered_order: 'Shares Pending Triggered Order',
    shares_pending_scheduling: 'Shares Pending Scheduling',
  } satisfies Record<GetB2bOrderDetailsResponse['status'], string>,
  operation: {
    subscription: 'Subscription',
    arbitrage: 'Arbitrage',
    redemption: 'Redemption',
    liquidation: 'Liquidation',
  } satisfies Record<GetB2bOrderDetailsResponse['operation'], string>,
  oddo_status: {
    sent: 'Sent',
    acknowledged: 'Acknowledged',
    confirmed: 'Confirmed',
    rejected: 'Rejected',
  } satisfies Record<Exclude<GetB2bOrderDetailsResponse['oddo_status'], null>, string>,
  cancellation_initiator: {
    user: 'User',
    bo: 'Back office',
    system: 'System',
  } satisfies Record<Exclude<GetB2bOrderDetailsResponse['cancellation_initiator'], null>, string>,
  cancellation_reason: {
    user_action: 'Cancelled by the user',
    shares_agent: 'Cancelled by a Shares agent',
    error: 'Cancelled by the broker or system unexpected error',
    compliance_verification_failed:
      'The user failed a verification (identity / name-matching check)',
    failed_deposit: 'Funding failed',
    insufficient_balance: 'Insufficient account balance',
    expired: 'The order is expired',
    skipped: 'Recurring execution skipped this order',
    order_not_tradable: 'The instrument was not tradable at execution time',
    sof_task_rejected: 'Source of funds compliance task was rejected',
  } satisfies Record<Exclude<GetB2bOrderDetailsResponse['cancellation_reason'], null>, string>,
};
